import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Avatar, Divider, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
export default function MenuPerfil() {

  const navigate = useNavigate();


  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openperfil, SetOpenPerfil] = React.useState(false)
  const user1 = sessionStorage.getItem('D')
  const datauser = JSON.parse(user1)
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseSesion = () => {
    sessionStorage.removeItem('%t');
    sessionStorage.removeItem('_sr3');
    sessionStorage.removeItem('D');
    sessionStorage.removeItem('_user');
    sessionStorage.removeItem('_s');
    sessionStorage.removeItem('p');
    navigate('/')
    window.location.reload()
    navigate('/')
  }

  return (<>

    <Grid container alignItems="center" justifyContent="flex-end" >

      <Grid item  >
        <IconButton color="inherit" onClick={handleClick}>
          <Avatar color='success'>
            <PersonOutlineIcon />
          </Avatar>
        </IconButton>

      </Grid>
      <Grid item  >
        <Typography
          color='secondary'
          component="h1"
          variant="h6"
          textAlign={'left'}
        >
          {datauser.nombre}
        </Typography>
      </Grid>
    </Grid>


    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
    >
      <MenuItem onClick={e => SetOpenPerfil(!openperfil)}>Perfil</MenuItem>
      <MenuItem onClick={handleCloseSesion}>Cerrar sesion</MenuItem>
    </Menu>


    <BootstrapDialog
      onClose={e => SetOpenPerfil(false)}
      aria-labelledby="customized-dialog-title"
      open={openperfil}
      maxWidth='lg'
    >



      <DialogContent >

        <Grid container alignContent='center' justifyContent='center' style={{ backgroundColor: '#688716' }}>

          <Grid item >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={e => SetOpenPerfil(false)} color='white'>
              Perfil del usuario
            </BootstrapDialogTitle>
            <Typography align='center' color='white' variant='h6'> <b>{datauser.nombre} {datauser.apellido}</b></Typography>

          </Grid>

        </Grid>
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item>
            <Typography align='center' variant='h6'> Rol: <b>{datauser.rol}</b></Typography>
            <Divider />
            <Typography variant='h6' align='center'>Nombre: <b>{datauser.nombre}</b></Typography>
            <Divider />
            <Typography variant='h6' align='center'> Apellido: <b>{datauser.apellido}</b></Typography>
            <Divider />
            <Typography variant='h6' align='center'> Correo: <b>{datauser.email}</b></Typography>
            <Divider />

          </Grid>


        </Grid>
        <br />
        <Grid container spacing={2}>

          <Grid item>


          </Grid>
          <Grid item>


          </Grid>
        </Grid>

      </DialogContent>

    </BootstrapDialog>
  </>
  );
}